/* Verolae · Wellness Journey — scroll-driven timeline progress.
   Port of the inline <script> of the source site "ceylon_wellness_journey" section:
   - the vertical track fill grows as the timeline scrolls; progress starts when the top of the
     timeline reaches 70% of the viewport height and completes after one timeline-height of scroll,
   - every dot whose centre lies under the filled part of the track gets `wj--active`,
   - scroll handling is throttled with requestAnimationFrame (passive listener),
   - the CTA reproduces the source button's onclick: smooth-scroll to the product form section
     when one exists on the page (otherwise the link is followed normally).
   Supports multiple instances (scoped per section root) and the Shopify theme editor. */
(function () {
  'use strict';

  var SELECTOR = '.wj-section[data-wj-section]';
  var FORM_SELECTOR = '[data-product-form], .product-form, .shopify-payment-button__button';

  function initWJ(root) {
    if (!root || root.getAttribute('data-wj-init') === 'true') return;

    var stepsEl = root.querySelector('.wj__steps');
    var trackFillEl = root.querySelector('.wj__track-fill');
    if (!stepsEl || !trackFillEl) return;

    var dots = Array.prototype.slice.call(stepsEl.querySelectorAll('[data-wj-dot]'));
    if (!dots.length) return;

    root.setAttribute('data-wj-init', 'true');

    function updateScrollProgress() {
      var rect = stepsEl.getBoundingClientRect();
      var windowH = window.innerHeight;

      // Progress starts when the timeline top reaches 70% of the screen height (source threshold)
      var startTrigger = windowH * 0.7;

      var totalDist = rect.height;
      if (!totalDist) return;

      var currentScroll = startTrigger - rect.top;

      var progress = Math.max(0, Math.min(currentScroll / totalDist, 1));
      trackFillEl.style.height = (progress * 100).toFixed(1) + '%';

      var fillPx = progress * totalDist;

      dots.forEach(function (dot) {
        var dotRect = dot.getBoundingClientRect();
        var dotCenter = dotRect.top - rect.top + dotRect.height * 0.5;
        if (fillPx >= dotCenter) {
          dot.classList.add('wj--active');
        } else {
          dot.classList.remove('wj--active');
        }
      });
    }

    var tickScheduled = false;
    function onScroll() {
      if (!tickScheduled) {
        tickScheduled = true;
        window.requestAnimationFrame(function () {
          updateScrollProgress();
          tickScheduled = false;
        });
      }
    }

    /* CTA: source behaviour was an inline onclick that scrolls to the product form section. */
    var cta = root.querySelector('[data-wj-cta]');
    function onCtaClick(e) {
      if (root.getAttribute('data-scroll-to-form') !== 'true') return;
      var el = document.querySelector(FORM_SELECTOR);
      if (!el) return; // no product form on this page: follow the link
      var target = el.closest('section, [data-section-id]') || el;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (cta) cta.addEventListener('click', onCtaClick);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', updateScrollProgress);
    window.addEventListener('load', updateScrollProgress);

    // Run once initially
    updateScrollProgress();

    root.wjDestroy = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', updateScrollProgress);
      window.removeEventListener('load', updateScrollProgress);
      if (cta) cta.removeEventListener('click', onCtaClick);
      root.removeAttribute('data-wj-init');
      root.wjDestroy = null;
    };
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, initWJ);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var nodes = (e.target || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (root) {
      if (typeof root.wjDestroy === 'function') root.wjDestroy();
    });
  });
})();
